<template>
  <v-chip
    class="ma-2 text-capitalize text-center"
    :color="priorityToColor()"
    label
    text-color="white"
    >{{ priorityCapitalized }}</v-chip
  >
</template>
<script>
export default {
  props: {
    priority: {
      type: String,
      default: 'Indefinida',
    },
  },
  methods: {
    priorityToColor() {
      if (this.priority.toUpperCase() === 'ALTA') {
        return 'red';
      }
      if (this.priority.toUpperCase() === 'BAIXA') {
        return 'green';
      }
      if (this.priority.toUpperCase() === 'MEDIA') {
        return 'yellow';
      } else {
        return 'grey';
      }
    },
  },
  computed: {
    priorityCapitalized() {
      if (this.priority.toUpperCase() === 'MEDIA') {
        return 'Média';
      }

      return this.priority.toLowerCase();
    },
  },
};
</script>
<style></style>
